import { Injectable } from '@angular/core';
import { NotificationCategory } from '@app/models/common/notification-category.model';
import { AuthService, NotifyService } from '@app/services';

@Injectable({
    providedIn: 'root',
})
export class NotificationCategoryService {
    private dataLoaded = false;
    private latestCategories: NotificationCategory[] = [];

    constructor(
        private notify: NotifyService,
        private auth: AuthService
    ) {}

    async getData(): Promise<void> {
        if (!this.dataLoaded) {
            try {
                const moduleIds = this.auth.company?.modules.map(({ id }) => id);

                const [notificationCategories] = await NotificationCategory.whereIn('module_id', moduleIds)
                    .orderBy('name', 'ASC')
                    .get();
                this.latestCategories = notificationCategories;
                this.dataLoaded = true;
            } catch (error) {
                this.notify.error(error);
                this.dataLoaded = false;
            }
        }
    }

    getLatestCategories(): NotificationCategory[] {
        return this.latestCategories;
    }
}
